// @flow
/** @jsx h */
import { h, Component } from 'preact'
import bem from '../../../lib/bem'
import { testReducedMotion } from '@nrk/feature-tests'

import { HTML5Video } from '../../lib/components/HTML5Video'

import styles from './VideoLoop.css'

type Props = {
  title?: string,
  leadParagraph?: string,
  href: string,
  poster: string,
  sources: {
    mp4: string,
    webm: string
  },
  size: {
    height: number,
    width: number
  }
}

type State = {
  supportsVideoAutoplay: boolean
}

export class VideoLoop extends Component<Props, State> {
  constructor (props: Props, state: State) {
    super(props, state)
    this.state = {
      supportsVideoAutoplay: false
    }
  }

  handleAutoPlay = (supportsVideoAutoplay: boolean) => {
    this.setState({
      supportsVideoAutoplay
    })
  }

  render () {
    const { title, poster, sources, href, size, leadParagraph } = this.props
    const { supportsVideoAutoplay } = this.state
    const paddingBottom = `${(size.height / size.width) * 100}%`
    const showFallbackImage = !supportsVideoAutoplay
    const autoPlay = !testReducedMotion()
    return (
      <div className={bem(styles.videoLoop, showFallbackImage && 'showFallbackImage')}>
        <a href={href}>
          <div className={styles.videoLoop__maxHeightWrapper}>
            <div className={styles.videoLoop__sizeWrapper} style={{ paddingBottom }}>
              <div className={styles.videoLoop__innerMaxHeightWrapper}>
                <img className={styles.videoLoop__fallbackImage} src={poster} alt='' />
                <HTML5Video className={styles.videoLoop__videoElement} preload='auto' autoPlay={autoPlay} loop playsInline muted
                  poster={poster}
                  sources={sources}
                  onAutoPlay={this.handleAutoPlay} />
              </div>
            </div>
          </div>
          { title && (
            <div className={`${styles.videoLoop__textWrapper} nrk-color-base`}>
              <h2 className={styles.videoLoop__title}>{title}</h2>
              { leadParagraph && <p className={styles.videoLoop__leadText}>{leadParagraph}</p> }
            </div>
          ) }
        </a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/v1/kurator/components/VideoLoop.js